import { IAm } from '@shared/types';
import { useCallback, useEffect, useRef, useState } from 'react';
import { CademyAPI } from '../../../../services/CademyAPI';
import { CademyError } from '@shared/domain-shared';
import { PublicCourse } from '@cademy-package/sdk-component-types';

export type Enrolments = {
    enrolmentId: string | null;
    subscriptionBenefits?: {
        membersOnlyAccess?: boolean;
        freeEntry?: boolean;
        discountedEntry?: number;
    };
};

export const useEnrolments = (iam: IAm | null, courseId: PublicCourse['_id']) => {
    const firstRun = useRef(true);
    const [enrolments, setEnrolments] = useState<Enrolments>({ enrolmentId: null });

    const loadEnrolments = useCallback(async () => {
        const response = await CademyAPI('GetCourseEnrolmentsSummary')({
            urlParams: { courseId },
        });

        if (response.statusCode === 200) {
            setEnrolments(response.body);
        } else {
            console.error(CademyError.fromUnknown(response.body));
        }
    }, [courseId]);

    useEffect(() => {
        if (iam && iam.authenticated && firstRun.current === true) {
            firstRun.current = false;
            loadEnrolments();
        }
    }, [iam, loadEnrolments]);

    return enrolments;
};
